module.exports = new __parcel__URL__("toxicity.30a59ce5.jpg").toString();